import { render, staticRenderFns } from "./ClientDemographicsGeneral.vue?vue&type=template&id=9df7cb7a"
import script from "./ClientDemographicsGeneral.vue?vue&type=script&lang=js"
export * from "./ClientDemographicsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports